// extracted by mini-css-extract-plugin
export var indeterminate = "_1o-5";
export var md = "_1o-4";
export var semantic = "_1o-6";
export var sm = "_1o-3";
export var text = "_1o-7";
export var toggleInput = "_1o-0";
export var toggleSwitch = "_1o-1";
export var xs = "_1o-2";